
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-group-i-prelims-test-series",
      function () {
        return require("private-next-pages/tnpsc-group-i-prelims-test-series/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-group-i-prelims-test-series"])
      });
    }
  